import request from '@/utils/request'

/** 查询指定公司的实物库存、占用、可用量、付款在途及供应商头寸。 */
export const getGoldWorkbench = companyID => request({ url: '/GoldAccount/Workbench', method: 'get', params: { companyID } })
/** 查询指定公司六个金料业务页签的待处理单据数量。 */
export const getGoldPendingCounts = companyID => request({ url: '/GoldAccount/PendingCounts', method: 'get', params: { companyID } })
/** 新建或启停公司总库/部门金料账户；新账户余额固定从零开始。 */
export const saveGoldAccount = data => request({ url: '/GoldAccount/Save', method: 'post', data })
/** 管理员按实盘目标克重修正已启用账户，并由服务端写入不可变审计流水。 */
export const adjustGoldAccount = data => request({ url: '/GoldAccount/Adjust', method: 'post', data })
/** 预览时间窗口内未认领的正式销售出库与有效售后退货入库。 */
export const previewGoldSales = data => request({ url: '/GoldDemand/PreviewSales', method: 'post', data })
/** 读取公司和材质最近一次成功汇总截止时间。 */
export const getLastGoldSalesCutoff = params => request({ url: '/GoldDemand/LastSalesCutoff', method: 'get', params })
/** 保存销售补料或供应商结算需求及可追溯来源。 */
export const saveGoldDemand = data => request({ url: '/GoldDemand/Save', method: 'post', data })
/** 提交草稿，锁定来源并进入财务定额。 */
export const submitGoldDemand = id => request({ url: '/GoldDemand/Submit/' + id, method: 'post' })
/** 查询金料需求汇总单列表。 */
export const getGoldDemands = params => request({ url: '/GoldDemand/List', method: 'get', params })
/** 查询需求表头、明细和已认领的销售/退货来源。 */
export const getGoldDemandDetail = id => request({ url: '/GoldDemand/Detail/' + id, method: 'get' })
/** 财务逐行确定批准量、内部调拨量和外采量。 */
export const approveGoldDemand = data => request({ url: '/GoldDemand/FinanceApprove', method: 'post', data })
/** 财务负责人对超过系统建议量的备货需求追加特批。 */
export const specialApproveGoldDemand = id => request({ url: '/GoldDemand/SpecialApprove/' + id, method: 'post' })
/** 对整张需求的全部外采明细统一定价，并在需求表头绑定唯一付款申请。 */
export const priceGoldDemand = data => request({ url: '/GoldPurchase/PriceDemand', method: 'post', data })
/** 查询采购付款类型的请款申请单中尚未被金料采购绑定的候选项。 */
export const getGoldPaymentCandidates = params => request({ url: '/GoldPurchase/PaymentCandidates', method: 'get', params })
/** 查询外采批次及其实时付款、在途、收货和分配状态。 */
export const getGoldPurchases = params => request({ url: '/GoldPurchase/List', method: 'get', params })
/** 查询单张金料采购以及收货、分配和关联单据。 */
export const getGoldPurchaseDetail = id => request({ url: '/GoldPurchase/Detail/' + id, method: 'get' })
/** 查询指定外采批次下的实际分批收货记录。 */
export const getGoldReceipts = purchaseID => request({ url: '/GoldPurchase/Receipts/' + purchaseID, method: 'get' })
/** 查询单个实际收货批次及其部门分配记录。 */
export const getGoldReceiptDetail = id => request({ url: '/GoldPurchase/ReceiptDetail/' + id, method: 'get' })
/** 需求已关联付款单后确认一次实际收货；付款审批状态独立跟踪。 */
export const receiveGold = data => request({ url: '/GoldPurchase/Receive', method: 'post', data })
/** 把实际收货批次分配到原申请部门；目标账户由服务端按公司、部门和材质自动解析。 */
export const allocateGold = data => request({ url: '/GoldPurchase/Allocate', method: 'post', data })
/** 财务登记退款或差异原因并关闭剩余短收量。 */
export const closeGoldShortReceipt = data => request({ url: '/GoldPurchase/ShortClose', method: 'post', data })
/** 查询公司总库到部门库的待交接及历史调拨。 */
export const getGoldTransfers = params => request({ url: '/GoldTransfer/List', method: 'get', params })
/** 查询单张内部调拨及其双边过账明细。 */
export const getGoldTransferDetail = id => request({ url: '/GoldTransfer/Detail/' + id, method: 'get' })
/** 确认内部实物交接并按公司总库移动均价双边过账。 */
export const confirmGoldTransfer = data => request({ url: '/GoldTransfer/Confirm', method: 'post', data })
/** 独立调用货品采购金料占用；正常采购保存流程已自动调用。 */
export const reservePurchaseGold = data => request({ url: '/GoldSupplierPosition/Reserve', method: 'post', data })
/** 释放尚未正式扣减的货品采购金料占用。 */
export const releasePurchaseGold = id => request({ url: '/GoldSupplierPosition/Release/' + id, method: 'post' })
/** 按实际回货金重核销预计值差异，退回少用量或生成新增欠料。 */
export const reconcileDeliveryGold = data => request({ url: '/GoldSupplierPosition/ReconcileDelivery', method: 'post', data })
/** 确认部门送厂还料并人工分摊指定欠料。 */
export const dispatchSupplierGold = data => request({ url: '/GoldSupplierPosition/Dispatch', method: 'post', data })
/** 查询逐货品采购明细记录的供应商欠料及结清状态。 */
export const getGoldDebts = params => request({ url: '/GoldSupplierPosition/Debts', method: 'get', params })
/** 查询单张欠料及其来源、结清与成本修正记录。 */
export const getGoldDebtDetail = id => request({ url: '/GoldSupplierPosition/DebtDetail/' + id, method: 'get' })
/** 查询按供应商、公司、部门和材质隔离的正向结余及负向欠料。 */
export const getGoldPositions = params => request({ url: '/GoldSupplierPosition/Positions', method: 'get', params })
/** 按会计月份及处理状态查询欠料成本修正记录。 */
export const getGoldCorrections = params => request({ url: '/GoldCostCorrection/List', method: 'get', params })
/** 导出指定会计月份的待处理成本修正报表。 */
export const exportGoldCorrections = accountingMonth => request({ url: '/GoldCostCorrection/Export', method: 'get', params: { accountingMonth } })
/** 登记财务已完成跨月/已售成本人工调整及其凭证号。 */
export const processGoldCorrections = data => request({ url: '/GoldCostCorrection/Process', method: 'post', data })

/** 搜索真实、可申请且未被提报的欠料或货品采购明细。 */
export const getGoldSettlementCandidates = params => request({ url: '/GoldDemand/SettlementCandidates', method: 'get', params })
